import { AssetTransfer } from '../entities/asset-transfer';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { UserInfo } from 'src/app/tools/models/entities/user-info';


export class AssetTransferRequest extends BaseRequest {
  
  assetTransfer : AssetTransfer;

  constructor(userInfo : UserInfo){    
    super(userInfo);
    this.assetTransfer = new AssetTransfer();
  }

}